$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).on('resize scroll', function () {
if ($('#shopify-section-about-metric-template').isInViewport()) {
      $('.metricpage-box').addClass('show');
    } else {
      $('.metricpage-box').removeClass('show');
    }
}); 